export const ADM_TRAINING_VISIBILITY_TOOLTIP =
  'Complete ADM training to enable profile visibility.'

export const ADM_TRAINING_PROMOTION_TOOLTIP =
  'Complete ADM training to enable promotion.'

export const getVisibilityDisabledTooltip = canPromoteContent =>
  canPromoteContent ? null : ADM_TRAINING_VISIBILITY_TOOLTIP
